import { reject } from 'lodash';
import { handleActions } from 'redux-actions';
import { CarQuoteList } from '@models/CarQuote';
import {
  carQuoteComparableAdd,
  CarQuoteComparableAddPayload,
  carQuoteComparableRemove,
  CarQuoteComparableRemovePayload,
  carQuoteComparableRemoveAll,
  stateReset,
  stateUpdate,
  State,
} from './action';

const initialState: State = {
  carQuotes: undefined,
  comparableCarQuotes: [],
};

const reducer = handleActions(
  {
    [String(carQuoteComparableAdd)]: (state, { payload }) => {
      const { carQuote } = payload as unknown as CarQuoteComparableAddPayload;

      return {
        ...state,
        comparableCarQuotes: [...state.comparableCarQuotes, carQuote] as CarQuoteList[],
      };
    },

    [String(carQuoteComparableRemove)]: (state, { payload }) => {
      const { carQuote } = payload as unknown as CarQuoteComparableRemovePayload;

      return {
        ...state,
        comparableCarQuotes: reject(state.comparableCarQuotes, ({ insurer }) => insurer.id === carQuote.insurer.id),
      };
    },

    [String(carQuoteComparableRemoveAll)]: (state) => {
      return {
        ...state,
        comparableCarQuotes: [],
      };
    },

    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },

    [String(stateReset)]: () => {
      return initialState;
    },
  },

  initialState,
);

export default reducer;
